import "./App.css";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import NotFound from "./Pages/NotFound";
import { useEffect, useState } from "react";
import "./Assets/Styles/style_pos";
import "./Assets/i18n/i18n";
import Home from "./Pages/home/home";
import PhuBaoAnGiaProduct from "./Pages/test/PhuBaoAnGiaProduct";
import PaymentProcess from "./Pages/payment/payment-process";
import AckSection from "./Pages/finish/ack-section";
import { ErrorPage } from "./Pages/error";
import EkycProcess from "./Pages/ekyc/ekyc-process";

function App() {
  useEffect(() => {
    document.body.classList.add("skin-blue", "sidebar-mini", "bg-phl");
    document.body.style.height = "100%";
    document.body.style.minHeight = "100%";
  }, []);

  const [objectDto, setObjectDto] = useState({step: 0});
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<Home objectDto={objectDto} setObjectDto={setObjectDto}/>} />
        <Route exact path="/*" element={<NotFound />} />
        <Route exact path="/payment" element={<PhuBaoAnGiaProduct />} />
        <Route exact path="/payment/callback" element={<PaymentProcess objectDto={objectDto} setObjectDto={setObjectDto}/>} />
        <Route exact path="/ekyc/callback" element={<EkycProcess objectDto={objectDto} setObjectDto={setObjectDto}/>} />
        <Route exact path="/contract-details/ack" element={<AckSection />} />
        <Route exact path="/error" element={<ErrorPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;